<script setup lang="ts">
import { computed, ref } from 'vue'
interface Props {
  disabled?: boolean
  buttonState?: 1 | 2 | 3 | 4 | 5
  ripple?: boolean
  tag?: 'a' | 'button' | 'router-link'
  fullWidth?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  buttonState: 1,
  disabled: false,
  ripple: false,
  tag: 'button',
  fullWidth: false,
})

const buttonStateClass = computed(() => {
  switch (props.buttonState) {
    case 2:
      return 'button_secondary'
    case 3:
      return 'button_dark-gray'
    case 4:
      return 'button_light-gray'
    case 5:
      return 'button_light-green'

    default:
      return ''
  }
})

const rippleSpan = ref(null)

const createRipple = (event) => {
  if (!props.ripple) {
    return
  }
  const button = event.currentTarget

  // const diameter = Math.max(button.clientWidth, button.clientHeight)
  // const radius = diameter / 2

  // rippleSpan.value.style.width = rippleSpan.value.style.height = `${diameter}px`
  // rippleSpan.value.style.top = `50%`
  // rippleSpan.value.classList.add('animated')
  // setTimeout(() => {
  //   rippleSpan.value.classList.remove('animated')
  // }, 1000)
}
</script>

<template>
  <component
    :is="tag"
    class="button"
    :class="`${buttonStateClass} ${disabled ? 'disabled' : ''} ${ripple ? 'ripple-effect' : ''} ${
      fullWidth ? 'full-width' : ''
    }`"
    :disabled="disabled"
    @click="createRipple"
    ref="button"
  >
    <span v-if="ripple" ref="rippleSpan" class="ripple-effect__span"></span>
    <div class="button__content">
      <slot name="start" />
      <div class="button__text"><slot /></div>
      <slot name="end" />
    </div>
  </component>
</template>

<style scoped lang="scss">
@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 0;
  }
}
.ripple-effect {
  position: relative;
  overflow: hidden;

  &__span {
    position: absolute; /* The absolute position we mentioned earlier */
    top: 0;
    left: 0;
    border-radius: 50%;
    transform: scale(0);

    background-color: rgba(255, 255, 255, 0.7);
    pointer-events: none;
  }
}

.animated {
  animation: ripple 600ms linear 0s;
}

.button {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
  border-radius: 30px;

  min-height: 44px;

  border: 1.5px solid $primary-green;
  background-color: $primary-green;
  color: $white;
  --svg-col: #{$white};

  @extend %hover-transition;

  &:before {
    content: '';
    position: absolute;
    top: -8px;
    right: -8px;
    bottom: -8px;
    left: -8px;
  }

  &_secondary {
  }

  &_dark-gray {
  }

  &_light-gray {
    background-color: $ui-gray-1;
    border-color: $ui-gray-1;
    color: $primary-text;
    --svg-col: #{$primary-text};
  }

  &_light-green {
    background-color: $sub-green;
    color: $primary-green;
    --svg-col: #{$primary-green};
    border: none;

    &:hover {
      color: $white;
      --svg-col: #{$white};
    }
  }

  &__content {
    display: flex;
    gap: 8px;
  }

  &__icon {
  }

  &__text {
    @include h4-6;
    display: flex;
    align-items: center;
    width: max-content;
  }

  &:hover {
    background-color: $hover-green;
    border-color: $hover-green;
  }

  &::active {
    background-color: $click-green;
    border-color: $click-green;
  }

  &.ripple-effect {
    border: none;
  }

  &.disabled {
    background-color: $white !important;
    color: $ui-gray-3 !important;
    --svg-col: #{$ui-gray-3} !important;
    border-color: $white !important;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15);
  }

  &.full-width {
    width: 100%;
  }
}
</style>
